module.exports = __webpack_public_path__ + "img/404-error.e25307ea.svg";